import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTimeCircleLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	id: "svg1",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { id: "defs1" }), /* @__PURE__ */ _jsx("path", {
		id: "path2",
		d: "M 12,2 C 6.4860055,2 2,6.4860055 2,12 2,17.513994 6.4860055,22 12,22 17.513994,22 22,17.513994 22,12 22,6.4860055 17.513994,2 12,2 Z m 0,1.5 c 4.686995,0 8.5,3.8130047 8.5,8.5 0,4.686995 -3.813005,8.5 -8.5,8.5 C 7.3130047,20.5 3.5,16.686995 3.5,12 3.5,7.3130047 7.3130047,3.5 12,3.5 Z m -0.337891,3.5957031 c -0.413999,0 -0.75,0.3360004 -0.75,0.75 v 4.8476559 c 0,0.264 0.139235,0.508532 0.365235,0.644532 l 3.769531,2.25 c 0.121,0.071 0.253766,0.105468 0.384766,0.105468 0.254999,0 0.503531,-0.132187 0.644531,-0.367187 0.212,-0.356 0.09523,-0.816297 -0.259766,-1.029297 L 12.412109,12.267578 V 7.8457031 c 0,-0.4139996 -0.335,-0.75 -0.75,-0.75 z"
	})]
});
export default SvgTimeCircleLine;
